import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Earn.module.css";
// import { Raffle } from './components/Raffle/Raffle';
import { QuestCarousel } from "./components/Quests/QuestCarousel";
import { TasksContainer } from "./components/TaskCards/TasksContainer";
import useApplicationSettings from "../../Store/ApplicationSettings";
import { getTasksGroup } from "../../Services/Requests";
import { TasksAdapter } from "./adapters/TasksAdapter";
import { TaskCard, QuestGroup } from "./types";
import { Loader } from "../../Components/Loader/Loader";
import Modal from "../../Components/Modal/Modal";
import DailyRewardModalContent from "../DailyReward/DailyRewardModalContent";
import { useModalStore } from "../../Store/ModalStore";
import { Raffle } from "./components/Raffle/Raffle";
export const Earn: React.FC = () => {
  const navigate = useNavigate();
  const tg = window.Telegram?.WebApp;
  const setShowMenubar = useApplicationSettings(
    (state: any) => state.setShowMenubar
  );
  const [tasks, setTasks] = useState<TaskCard[]>([]);
  const [quests, setQuests] = useState<QuestGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const setOpen = useModalStore((state) => state.setOpen);
  const open = useModalStore((state) => state.open);
  const handleClose = useModalStore((state) => state.handleClose);
  const [dailyRewardOpen, setDailyRewardOpen] = useState(false);
  useEffect(() => {
    setShowMenubar(true);

    const handleBackClick = () => navigate("/");

    if (tg && tg.BackButton) {
      tg.BackButton.show();
      tg.BackButton.onClick(handleBackClick);
    } else {
      console.warn("Telegram WebApp BackButton не доступен при монтировании.");
    }

    setLoading(true);
    getTasksGroup((data: any) => {
      console.log("Все полученные задания:", data);

      // Используем адаптер для преобразования данных
      const { individualTasks, combinedTasks } = TasksAdapter.adaptTasks(data);

      console.log("Индивидуальные задания:", individualTasks);
      console.log("Комбинированные задания (квесты):", combinedTasks);

      setTasks(individualTasks);
      setQuests(combinedTasks);
      setLoading(false);
    });

    return () => {
      if (tg && tg.BackButton) {
        tg.BackButton.offClick(handleBackClick);
        tg.BackButton.hide();
      }
    };
  }, [navigate, setShowMenubar]);

  const handleModalShow = () => {
    setDailyRewardOpen(true);
    setOpen('dailyReward');
  };

  const handleModalClose = () => {
    setDailyRewardOpen(false);
    handleClose();
  };

  return (
    <div className={styles.container + (loading ? " " + styles.loading : "")}>
      {loading ? (
        <Loader size="medium" text="" />
      ) : (
        <>
          <Raffle />
          <QuestCarousel quests={quests} />
          <TasksContainer tasks={tasks} onModalShow={handleModalShow} />
          {open === 'dailyReward' && (
            <Modal>
              <DailyRewardModalContent onClose={handleModalClose} />
            </Modal>
          )}
        </>
      )}
    </div>
  );
};

export default Earn;
